export const WIDGET_TYPES = {
    701: {
        widget: 'alert',
        size: 'Portrait',
        name: 'CustomerAlerts'
    },
    702: {
        widget: 'alert',
        size: 'Portrait',
        name: 'ProductFieldsAlerts'
    },
    601: {
        widget: 'fields',
        size: 'Landscape',
        name: 'CustomerFields'
    },
    602: {
        widget: 'fields',
        size: 'Landscape',
        name: 'ProductFields'
    },
    501: {
        widget: 'fields',
        size: 'Portrait',
        name: 'CustomerFields'
    },
    502: {
        widget: 'fields',
        size: 'Portrait',
        name: 'ProductFields'
    },
    403: {
        widget: 'grid',
        size: 'Landscape',
        name: 'PickSlips'
    },
    404: {
        widget: 'grid',
        size: 'Landscape',
        name: 'InventoryQuantities'
    },
    402: {
        widget: 'grid',
        size: 'Landscape',
        name: 'OutstandingQuotes'
    },
    401: {
        widget: 'grid',
        size: 'Landscape',
        name: 'OutstandingEnquiries'
    }
};

export const RESPONSE_KEY_MAP: Record<string, string> = {
    OutstandingEnquiries: 'OutstandingEnquiries',
    OutstandingQuotes: 'OutstandingQuotes',
    PickSlips: 'PickSlips'
};

export const PROGRAM = {
    CUSTOMER_ENQUIRY: 'customer-enquiry',
    INVENTORY_ENQUIRY: 'inventory-enquiry',
    PICKSLIPS: 'pickslips'
};
